/**
 * `pageContext()`
 *
 * Returns page-context object from Django
 *
 */

import {Severity} from '@sentry/browser'
import {Resolver} from 'airship/utils/resolvers/types'
import reportError from 'airship/modules/report-error'

let cachedContext: unknown = null

export default function pageContext<T>(
  resolver?: Resolver<T>,
  /** For unit testing only: skip the cache and fetch from the DOM again. */
  ignoreCache = false
): T {
  if (!ignoreCache && cachedContext) return cachedContext as T

  const el = document.getElementById('js-page-context')

  if (!el) {
    return {} as T
    // throw new Error('js-page-context element not found')
  }

  const json = el.innerText.trim()

  const context = JSON.parse(JSON.parse(json))

  // If a resolver is provided, warn if it doesn't pass
  try {
    resolver && resolver(context)
  } catch (e) {
    reportError(e, {level: Severity.Warning})
  }

  cachedContext = context
  return context
}
